<template>
	<div class="home">
		<top :p="0"></top>
		
		<lbt></lbt>
		
		<div class="wei">
			<div class="wei_box">
				<div class="more">
					<img class="moreimg" src="../static/home/more.png" alt="">
					<div class="more_box">
						<span v-if="lang==1">服务导向</span>
						<span v-if="lang==2">service</span>
						<span v-if="lang==3">サービス</span>
						<span v-if="lang==4">서비스</span>
					</div>
				</div>
				<div class="wei_option">
					<div class="w_box">
						<span v-if="lang==1">咨询热线</span>
						<span v-if="lang==2">hotline</span>
						<span v-if="lang==3">ねっせん</span>
						<span v-if="lang==4">핫라인</span>
						
						<div class="w_text">
							023-48264666
						</div>
					</div>
					
					<div class="w_box" @click="nvu(2)">
						
						<span v-if="lang==1">旅游指南</span>
						<span v-if="lang==2">Shopping</span>
						<span v-if="lang==3">ガイド</span>
						<span v-if="lang==4">안내서</span>
					</div>
					<!-- <div class="w_box" @click="nvu(3)">
						
						<span v-if="lang==1">餐饮美食</span>
						<span v-if="lang==2">delicacy</span>
						<span v-if="lang==3">グルメ</span>
						<span v-if="lang==4">음식 음식</span>
					</div> -->
					<div class="w_box" @click="nvu(4)">
						
						<span v-if="lang==1">酒店住宿</span>
						<span v-if="lang==2">stay</span>
						<span v-if="lang==3">宿泊する</span>
						<span v-if="lang==4">숙박</span>
					</div>
					<div class="w_box" @click="nvu(5)">
						
						<span v-if="lang==1">门票预订</span>
						<span v-if="lang==2">book</span>
						<span v-if="lang==3">購読する</span>
						<span v-if="lang==4">가입</span>
					</div>
				</div>
				<div class="erwei">
					<img src="../static/home/xbjg.jpg" alt="">
				</div>
				<div class="erwei_name">
					
					<span v-if="lang==1">扫码关注微信公众号</span>
					<span v-if="lang==2">WeChat QR code scanning</span>
					<span v-if="lang==3">ウィーチャットスキャンコード</span>
					<span v-if="lang==4">위챗 스캔</span>
				</div>
			</div>
		</div>
		
		<bar></bar>
	</div>
</template>

<script>
import top from '../components/top.vue'
import bar from '../components/bar.vue'
import lbt from '../components/lbt.vue'

export default {
	name: 'HomeView',
	data() {
		return {
			lang:1,		//语言
		}
	},
	created() {
		this.lang = JSON.parse(localStorage.getItem("langs")) || 1
	},
	components: {
		top,
		bar,
		lbt,
		
	},
	methods:{
		nvu(e){
			
			if(e==1){
				if(this.$route.name == 'overview3'){
					this.$router.replace('/refresh')
				}else{
					this.$router.push({name:'overview3',query:{nums:1}})
				}
			}
			if(e==2){
				if(this.$route.name == 'guide'){
					this.$router.replace('/refresh')
				}else{
					this.$router.push({name:'guide',query:{nums:2}})
				}
			}
			
			if(e==3){
				if(this.$route.name == 'book'){
					this.$router.replace('/refresh')
				}else{
					this.$router.push({name:'book',query:{nums:1}})
				}
			}
			if(e==4){
				if(this.$route.name == 'book'){
					this.$router.replace('/refresh')
				}else{
					this.$router.push({name:'book',query:{nums:1}})
				}
			}
			if(e==5){
				if(this.$route.name == 'book'){
					this.$router.replace('/refresh')
				}else{
					this.$router.push({name:'book',query:{nums:3}})
				}
			}
			
		}
		
	},
	
}
</script>

<style scoped lang="less">
	.home{
		width: 1920px;
		height: 100vh;
		position: relative;
		overflow: hidden;
	}
	
	// 
	.wei{
		width: 224px;
		height: 348px;
		background-image: url('../static/home/mogu.png');
		background-repeat: no-repeat;
		background-size: 100% 100%;
		position: fixed;
		z-index: 10;
		right: 0;
		top: 50%;
		transform:translateY(-50%);
		color: #333333;
	}
	.wei_box{
		width: 161px;
		margin-left: 50px;
	}
	.more{
		box-sizing: border-box;
		padding-top: 45px;
		height: 77px;
		border-bottom: 1px solid #e3e3e3;
		display: flex;
		justify-content: center;
	}
	.moreimg{
		width: 24px;
		height: 14px;
		margin-right: 14px;
	}
	.more_box{
		font-size: 24px;
		line-height: 18px;
	}
	.wei_option{
		padding-top: 1px;
		height: 89px;
		border-bottom: 1px solid #e3e3e3;
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		position: relative;
	}
	
	.w_box{
		width: 80px;
		height: 14px;
		line-height: 14px;
		font-size: 18px;
		text-align: center;
		margin-top: 6px;
		font-family: "微软雅黑";
		
	}
		.w_text{
			display: none;
			padding: 10px 20px;
			position: absolute;
			top: 10px;
			right: 180px;
			font-size: 18px;
			color: #fff;
			background-color: rgba(0, 0, 0, .6);
			white-space: nowrap;
		}
		.w_box:nth-child(1):hover .w_text{
			display: block;
		}
	
	.w_box:hover{
		color: #e3742a;
	}
	.erwei{
		margin: auto;
		margin-top: 19px;
		width: 113px;
		height: 113px;
		background-color: #e3742a;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.erwei_name{
		font-size: 12px;
		text-align: center;
		margin-top: 13px;
	}
	
</style>
